export default __webpack_public_path__ + "static/priicer-7d0e45fb400e1a174b926a16101ab606.png";